/**
 * Maximum size for one uploaded file (invoices and supporting documents).
 *
 * Keep in sync with the backend limit in hr-java-backend
 * (`app.upload.max-file-size` / `spring.servlet.multipart.max-file-size`,
 * both driven by the UPLOAD_MAX_FILE_SIZE env var, default 10MB) and with the
 * `upload.acceptedFormats` copy ("Max 10MB"). Changing the backend env var
 * requires a coordinated frontend release.
 */
export const MAX_UPLOAD_FILE_SIZE_MB = 10;
export const MAX_UPLOAD_FILE_SIZE_BYTES = MAX_UPLOAD_FILE_SIZE_MB * 1024 * 1024;

export const isFileTooLarge = (file: File): boolean => file.size > MAX_UPLOAD_FILE_SIZE_BYTES;
